import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import {
  CREATE_DEFAULT_QUOTE_FUNNELS,
  GET_AGENT_PROFILE,
  GET_AGENT_PROFILE_POPUP_MESSAGE,
  GET_QUOTE_FUNNELS,
  MODIFY_AGENT_PROFILE,
  MODIFY_QUOTE_FUNNEL,
  UPLOAD_AGENT_PROFILE_IMAGES
} from "./actionTypes"

import {
  getAgentProfileSuccess,
  getAgentProfileError,
  modifyAgentProfileSuccess,
  modifyAgentProfileError,
  getQuoteFunnelsSuccess,
  getQuoteFunnelsError,
  modifyQuoteFunnelSuccess,
  modifyQuoteFunnelError,
  createDefaultQuoteFunnelsSuccess,
  uploadAgentProfileImagesSuccess,
  uploadAgentProfileImagesError,
  getAgentProfilePopupMessageSuccess,
  getAgentProfilePopupMessageError,
} from "./actions"
import { AppConfiguration } from "config"
import { genericGetRequest, genericPostRequest, genericPutRequest, putAgentProfileImages } from "helpers/sf_backend_helper"
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils"

function* onGetAgentProfile() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/agent_profiles`,
      {},
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': getCurrentBrandFromLocalStorage()?.id
      }
    )
    yield put(getAgentProfileSuccess(response))
  } catch (error) {
    yield put(getAgentProfileError(error))
  }
}

function* onGetAgentProfilePopupMessage(action) {
  try {
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/agent_profiles/${action.payload}/popup_messages`;
    const request_body = action;
    const request_headers = { "Content-type": "application/json" }
    let response = yield call(genericGetRequest, URL, request_body, request_headers)
    yield put(getAgentProfilePopupMessageSuccess(response))
  } catch (error) {
    yield put(getAgentProfilePopupMessageError(error))
  }
}

function* onModifyAgentProfile(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/agent_profiles/${action?.payload?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': getCurrentBrandFromLocalStorage()?.id
        }
      }
    )
    yield put(modifyAgentProfileSuccess(response))
  } catch (error) {
    yield put(modifyAgentProfileError(error))
  }
}

function* onUploadAgentProfileImages({ payload: { agent_profile, upload_image_type } }) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let response = yield call(
      putAgentProfileImages,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_presigned_url_for_agent_profile`,
      {
        payload: agent_profile,
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
          'brand-id': getCurrentBrandFromLocalStorage()?.id
        }
      }
    )
    yield put(uploadAgentProfileImagesSuccess(response, upload_image_type))
  } catch (error) {
    yield put(uploadAgentProfileImagesError(error))
  }
}

function* onGetQuoteFunnels(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/quote_funnels`,
      { ...action?.payload?.queryParams },
      {
        Authorization: user.token,
        'account-id': user.account_id
      }
    )
    yield put(getQuoteFunnelsSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsError(error))
  }
}

function* onModifyQuoteFunnel(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/quote_funnels/${action?.payload?.quote_funnel?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(modifyQuoteFunnelSuccess(response))
  } catch (error) {
    yield put(modifyQuoteFunnelError(error))
  }
}

function* onCreateDefaultQuoteFunnels() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    let response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/create_default_quote_funnels`,
      {
        body: {},
        headers: {
          Authorization: user.token,
          'account-id': user.account_id
        }
      }
    )
    yield put(createDefaultQuoteFunnelsSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelsError(error))
  }
}

function* QuoteFunnelSaga() {
  yield takeEvery(GET_AGENT_PROFILE, onGetAgentProfile)
  yield takeEvery(GET_AGENT_PROFILE_POPUP_MESSAGE, onGetAgentProfilePopupMessage)
  yield takeEvery(MODIFY_AGENT_PROFILE, onModifyAgentProfile)
  yield takeEvery(UPLOAD_AGENT_PROFILE_IMAGES, onUploadAgentProfileImages)
  yield takeEvery(GET_QUOTE_FUNNELS, onGetQuoteFunnels)
  yield takeEvery(MODIFY_QUOTE_FUNNEL, onModifyQuoteFunnel)
  yield takeEvery(CREATE_DEFAULT_QUOTE_FUNNELS, onCreateDefaultQuoteFunnels)
}

export default QuoteFunnelSaga